export default {
  // 食谱分类列表
  CHANGE_RECIPE_CATEGORY_LIST(state, list) {
    state.recipeCategoryListState = list;
  },

  // 标签列表
  CHANGE_TAG_LIST(state, list) {
    state.tagListState = list;
  },

  // 型号列表
  CHANGE_PRODUCT_LIST(state, list) {
    state.productListState = list;
  },

  // 工作模式列表
  WORK_MODE_LIST(state, list) {
    state.workModeListState = list;
  }
}
